var i = /* @__PURE__ */ ((l) => (l.large = "large", l.medium = "medium", l.small = "small", l.lg = "lg", l.md = "md", l.sm = "sm", l))(i || {}), a = /* @__PURE__ */ ((l) => (l.outline = "outline", l["outline-light"] = "outline-light", l.fill = "fill", l["fill-light"] = "fill-light", l))(a || {});
const n = (l) => {
  switch (l) {
    case "lg":
    case "large":
      return "input-lg";
    case "md":
    case "medium":
      return "input-md";
    case "sm":
    case "small":
      return "input-sm";
    default:
      return "input-md";
  }
}, u = (l) => {
  switch (l) {
    case "outline":
      return "input-field-outline";
    case "outline-light":
      return "input-field-outline-light";
    case "fill-light":
      return "input-field-light";
    case "fill":
    default:
      return "";
  }
}, d = (l) => {
  const e = "input-field", s = u(l);
  return `${e} ${s}`;
}, r = (l) => {
  const e = "input input-primary", s = l.disabled ? "input-disabled" : "", t = l.invalid ? "input-invalid" : "";
  return `${e} ${s} ${t}`;
}, c = (l) => {
  const e = r(l), s = n(l.size);
  return `${e} ${s}`;
};
export {
  i as InputSize,
  a as InputVariant,
  d as getInputFieldStyleClasses,
  c as getInputLabelStyleClasses,
  r as getTextareaLabelStyleClasses
};
